
// Usado para setear el objeto global con la configuración del PUSHER
export default 'SET_GLOBAL_PUSHER_INSTANCE';
